import { getAssetURL } from "helpers/assets";

const TARALITE_ICON_GCS_PATH = "taralite-com/assets/images/icons";

const bottleIcon = getAssetURL(`${TARALITE_ICON_GCS_PATH}/bottle.svg`);
const callOmuIcon = getAssetURL(`${TARALITE_ICON_GCS_PATH}/call-omu.svg`);
const directComissionIcon = getAssetURL(
  `${TARALITE_ICON_GCS_PATH}/direct-comission.svg`
);
const easeRunningBusinessIcon = getAssetURL(
  `${TARALITE_ICON_GCS_PATH}/ease-running-business.svg`
);
const envelopeIcon = getAssetURL(`${TARALITE_ICON_GCS_PATH}/envelope.svg`);
const webBorrowerIcon = getAssetURL(
  `${TARALITE_ICON_GCS_PATH}/web_borrower.svg`
);
const webBuildingIcon = getAssetURL(
  `${TARALITE_ICON_GCS_PATH}/web_building.svg`
);
const webDisbursementIcon = getAssetURL(
  `${TARALITE_ICON_GCS_PATH}/web_disbursement.svg`
);
const webNegotiableIcon = getAssetURL(
  `${TARALITE_ICON_GCS_PATH}/web_negotiable.svg`
);
const webRibbonIcon = getAssetURL(`${TARALITE_ICON_GCS_PATH}/web_ribbon.svg`);
const webUnlockIcon = getAssetURL(`${TARALITE_ICON_GCS_PATH}/web_unlock.svg`);
const phoneIcon = getAssetURL(`${TARALITE_ICON_GCS_PATH}/phone.svg`);
const rimaWebBorrowerIcon = getAssetURL(
  `${TARALITE_ICON_GCS_PATH}/rima_web_borrower.svg`
);
const handCoinIcon = getAssetURL(`${TARALITE_ICON_GCS_PATH}/hand_coin.svg`);
const walletIcon = getAssetURL(`${TARALITE_ICON_GCS_PATH}/wallet.svg`);
const handMoneyIcon = getAssetURL(`${TARALITE_ICON_GCS_PATH}/hand_money.svg`);
const handHomeIcon = getAssetURL(`${TARALITE_ICON_GCS_PATH}/hand_home.svg`);
const chevronLeft = getAssetURL(`${TARALITE_ICON_GCS_PATH}/chevron-left.svg`);
const chevronRight = getAssetURL(`${TARALITE_ICON_GCS_PATH}/chevron-right.svg`);

export {
  bottleIcon,
  callOmuIcon,
  directComissionIcon,
  easeRunningBusinessIcon,
  envelopeIcon,
  webBorrowerIcon,
  webBuildingIcon,
  webDisbursementIcon,
  webNegotiableIcon,
  webRibbonIcon,
  webUnlockIcon,
  phoneIcon,
  rimaWebBorrowerIcon,
  handCoinIcon,
  walletIcon,
  handMoneyIcon,
  handHomeIcon,
  chevronLeft,
  chevronRight,
};
